import {Dispatch} from 'redux';
import {ErrorDto} from '../../../models/dtos/error.dto';
import {Errors} from '../../../utilities/errors';
import {REWARD_CONSUME_START, REWARD_CONSUME_SUCCESS, REWARD_CONSUME_FAIL, REWARD_CONSUME_RESET} from './constants';
import {RewardConsumeStartAction, RewardConsumeSuccessAction, RewardConsumeFailAction, RewardConsumeResetAction} from './types';
import {rewardConsumeRequest} from './repository';

const rewardConsumeStartAction = (): RewardConsumeStartAction => {
  return {
    type: REWARD_CONSUME_START,
  };
};
const rewardConsumeSuccessAction = (payload: boolean): RewardConsumeSuccessAction => {
  return {
    type: REWARD_CONSUME_SUCCESS,
    payload: payload,
  };
};
const rewardConsumeFailAction = (error: ErrorDto): RewardConsumeFailAction => {
  return {
    type: REWARD_CONSUME_FAIL,
    error: error,
  };
};
const rewardConsumeResetAction = (): RewardConsumeResetAction => {
  return {
    type: REWARD_CONSUME_RESET,
  };
};

export const rewardConsume = () => async (dispatch: Dispatch) => {
  try {
    dispatch(rewardConsumeStartAction());
    await rewardConsumeRequest();
    dispatch(rewardConsumeSuccessAction(true));
  } catch (error) {
    dispatch(rewardConsumeFailAction(Errors.getErrorDtoFromApiError(error)));
  }
};

export const rewardConsumeReset = () => (dispatch: Dispatch) => {
  dispatch(rewardConsumeResetAction());
};
